import { render, staticRenderFns } from "./QuickTaskCreator.vue?vue&type=template&id=3b80a45c&scoped=true&"
import script from "./QuickTaskCreator.vue?vue&type=script&lang=ts&"
export * from "./QuickTaskCreator.vue?vue&type=script&lang=ts&"
import style0 from "./QuickTaskCreator.vue?vue&type=style&index=0&id=3b80a45c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b80a45c",
  null
  
)

export default component.exports